module.exports = __webpack_public_path__ + "static/media/Delete.de08b20e.svg";